import React from 'react';
import PropTypes from 'prop-types';
import Document from '../common/exhibitingOrganisation/Document';
import Classes from '../common/Classes';

const DocumentsSection = ({
  documents, translations, tags, exhibitorId, locale, productId, mixpanelProps
}) => {
  if (documents.length === 0) {
    return null;
  }

  return (
    <div className={Classes.documentSection}>
      <hr />
      <h2>{translations.sectionTitle}</h2>
      <div className={Classes.topBottomPadded}>
        {documents.map(document =>
          (<Document
            key={document.id}
            document={document}
            translations={translations}
            tags={tags}
            exhibitorId={exhibitorId}
            productId={productId}
            locale={locale}
            isEditable={false}
            mixpanelProps={mixpanelProps}
          />))
        }
      </div>
    </div>
  );
};

DocumentsSection.propTypes = {
  documents: PropTypes.array.isRequired,
  translations: PropTypes.object.isRequired,
  tags: PropTypes.shape({
    download: PropTypes.string.isRequired
  }).isRequired,
  exhibitorId: PropTypes.string.isRequired,
  locale: PropTypes.string.isRequired,
  productId: PropTypes.string,
  mixpanelProps: PropTypes.object,
};

export default DocumentsSection;
